import React, { Component } from 'react'
import { View, TextInput, Keyboard, Platform } from 'react-native'
import Slider from '../../Atoms/VerticalSlider'
import styled from 'styled-components/native'

import Icon from '../../Atoms/Icon'
import Touchable from '../../Atoms/Touchable'
import CardHelp from '../../Molecules/CardHelp'
import { Text } from '../../Atoms/Typography'
import TranslatedText from '../../Atoms/TranslatedText'
import PageHeader from '../../Molecules/PageHeader'
import InlineError from '../../Atoms/InlineError'
import { thousandSeparator, percentage } from '../../../lib/formatters'
import { translate } from '../../../services/translate'
import theme from '../../../styles/theme'
import { calculateCapitalMovement, calculateForecastValues, calculateRiskWeightedAssets, calculateForecastDeductions } from './calculations'

const sliderHeight = 440
const valueBoxWidth = 90

const isIOSOrWeb = Platform.OS === 'ios' || Platform.OS === 'web'

const noteMessage = 'Indicates estimates only which\nare subject to actual perfomance'
const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const Content = styled(View)`
  flex: 1;
  flex-direction: row;
  padding: ${theme.gutterUnit}px;
  padding-right: ${3 * theme.gutterUnit}px;
`

const StyledInput = styled(TextInput)`
  height: 30px;
  width: 75px;
  border-color: ${props => props.editable ? theme.colours.grey : theme.colours.grey};
  background-color: ${props => props.editable ? theme.colours.blue : theme.colours.grey};
  border-width: 1px;
  border-radius: 5px;
  color: ${props => props.editable ? theme.colours.white : theme.colours.black}
`

const ShareCapitalIssuedContainer = styled(View)`
  align-items: center;
  justify-content: ${isIOSOrWeb ? 'flex-start' : 'space-between'};
  width: ${(100 - 23) / 2}%;
`

const ForecastContainer = styled(View)`
  align-items: center;
  justify-content: ${isIOSOrWeb ? 'flex-start' : 'space-between'};
  width: ${(100 - 23) / 2}%;
  margin-left: ${theme.gutterUnit}px;
`

const SlidersContainer = styled(View)`
  flex-direction: row;
  width: 23%;
`

const SliderValueContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: ${theme.gutterUnit}px;
  ${isIOSOrWeb ? `margin-top: ${sliderHeight + 4 * theme.gutterUnit}px;` : ''}
`

const SliderValue = styled(View)`
  width: ${valueBoxWidth}px;
  padding-top: ${theme.gutterUnit}px;
  padding-bottom: ${theme.gutterUnit}px;
  border-width: 1px;
  border-color: ${props => props.mandatory ? theme.colours.blue : theme.colours.bordergrey};
  background-color: ${props => props.mandatory ? theme.colours.blue : theme.colours.white};
  border-radius: 5px;
`

const FakeInput = styled(View)`
  height: 30px;
  width: 75px;
  border-color: ${theme.colours.grey};
  background-color: ${theme.colours.blue};
  border-width: 1px;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
`

const VerticalSliderColumn = styled(View)`
  width: 50%;
  align-items: center;
  justify-content: ${isIOSOrWeb ? 'flex-start' : 'space-between'};
  padding-top: ${0.5 * theme.gutterUnit}px;
`

const ColumnHeaderContainer = styled(View)`
  height: 40px;
  width: 100%;
`

const DenominationContainer = styled(View)`
  align-items: flex-end;
  padding-right: ${theme.gutterUnit}px;
`

const ContentContainer = styled(View)`
  border-color: ${theme.colours.bordergrey};
  border-width: 1px;
  width: 100%;
  height: 440px;
  background-color: ${theme.colours.white};
  ${isIOSOrWeb ? `margin-top: ${theme.gutterUnit * 2}px;` : ''}
`

const Section = styled(View)`
  border-color: ${theme.colours.bordergrey};
  border-bottom-width: 1px;
  padding-left: ${theme.gutterUnit}px;
  padding-right: ${theme.gutterUnit}px;
`

const Row = styled(View)`
  flex-direction: row;
  padding-top: ${1.25 * theme.gutterUnit}px;
  padding-bottom: ${1.25 * theme.gutterUnit}px;
  justify-content: space-between;
  align-items: center;
`

const Footer = styled(View)`
  height: 70px;
  width: 100%;
  border-color: ${theme.colours.bordergrey};
  border-width: 1px;
  flex-direction: row;
  padding: ${2 * theme.gutterUnit}px;
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.colours.white};
  ${isIOSOrWeb ? `margin-top: ${theme.gutterUnit * 2}px;` : ''}
`

const GreyFooter = styled(Footer)`
  background-color: ${theme.colours.grey};
 ${isIOSOrWeb ? `margin-top: ${theme.gutterUnit * 2}px;` : ''}
`

const Slider1Container = styled(View)`
  position: absolute;
  transform: rotate(${Platform.select({ web: '90deg', default: '-90deg' })});
  width: ${sliderHeight}px;
  top: 260px;
`

const HelpIcon = styled(View)`
  height: 30px;
`

const formatValue = (val, input = false) => {
  if (val === 0) {
    return '0'
  }
  if (Platform.OS === 'web' && input) {
    return `${val}`
  }
  if (val < 0) {
    return `(${thousandSeparator(val * -1)})`
  }
  return `${thousandSeparator(val)}`
}

const formatPercentage = (val, dp, hidePercentage) => {
  if (val === 0) {
    return '-'
  }
  return percentage(val, dp, hidePercentage)
}

const getBand = (possibleBands, value) => {
  for (let i = 0; i < possibleBands.length; i++) {
    const potentialBand = possibleBands[i]

    if (potentialBand.bandValue <= value) {
      return potentialBand.bandName
    }
  }
  return null
}

export default class TreasuryPage4 extends Component {
  state = {
    error: null,
    cardHelp: {
      isVisible: false,
      styles: {
        left: 0,
        top: 0
      },
      heading: '',
      body: ''
    }
  }

  _onPressHelp = (evt, heading, body, styles) => {
    if (heading !== this.state.cardHelp.heading) {
      this.setState({
        cardHelp: {
          isVisible: true,
          styles,
          heading,
          body
        }
      })
    }
  }

  handlePressCloseHelp = () => {
    this.setState({
      cardHelp: {
        isVisible: false,
        styles: {
          left: 0,
          top: 0
        },
        heading: '',
        body: ''
      }
    })
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (!nextProps.active) {
      return false
    }
    return true
  }

  componentDidMount () {
    this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow)
    this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide)
  }

  componentWillUnmount () {
    this.keyboardDidShowListener.remove()
    this.keyboardDidHideListener.remove()
  }

  _keyboardDidShow = () => {
    if (!this.props.active) {
      return
    }
    this.setState({ error: null })
    this.tempValue = null
    this.tempType = null
  }

  _keyboardDidHide = () => {
    if (!this.props.active) {
      return
    }
    if (this.tempValue == null || typeof this.tempValue !== 'string') {
      return
    }
    let tempValue = this.tempValue.replace(/,/i, '')
    tempValue = tempValue.replace('(', '-').replace(')', '')
    if (isNaN(tempValue) || parseInt(tempValue).toString() !== tempValue) {
      return this.setState({ error: 'Input must be a whole number between -99000 and +99000' })
    }
    const val = parseInt(tempValue)
    if (val < -99000 || val > 99000) {
      return this.setState({ error: 'Input must be a whole number between -99000 and +99000' })
    }

    const valuesToChange = {
      [this.tempType]: val
    }

    this.props.onChangeValue(valuesToChange)
  }

  onInput = (type, val) => {
    this.tempValue = val
    this.tempType = type
  }

  onBlur = (type) => {
    this._keyboardDidHide()
  }

  onDividendsReinvestedChange = (val) => {
    this.props.onChangeValue({ dividendsReinvested: val })
  }

  onShareIssuesBuyBacksChange = (val) => {
    this.props.onChangeValue({ capitalRatioChange: val })
  }

  renderInput = (field, defaultValue, percentage) => {
    return (
      <StyledInput
        onChangeText={(val) => this.onInput(field, val)}
        defaultValue={percentage ? formatPercentage(defaultValue, 0, true) : formatValue(defaultValue, true)}
        autoCorrect={false}
        underlineColorAndroid='transparent'
        keyboardType='numeric'
        editable={this.props.enableChanges}
        onBlur={() => this.onBlur(field)}
        style={{ textAlign: 'center', fontFamily: 'ubuntu-medium', fontSize: 18 }}
      />
    )
  }

  render () {
    const { treasury: { capitalBands, denomination, openingBalances, capitalSliderMin, capitalSliderMax, dividendsReinvestedHelpTitle, dividendsReinvestedHelpBody, additionalShareIssuesHelpTitle, additionalShareIssuesHelpBody }, decisions, enableChanges } = this.props
    const assetForecasts = calculateForecastValues(false, openingBalances, decisions)

    const { totalRiskWeightedAsset } = calculateRiskWeightedAssets(assetForecasts, decisions)

    const { totalCapitalDeductions } = calculateForecastDeductions(assetForecasts, decisions)
    const targetShareCapitalMovement = calculateCapitalMovement(totalRiskWeightedAsset, -1 * totalCapitalDeductions, decisions, openingBalances)
    const retainedNpat = decisions.groupNpat < 0 ? decisions.groupNpat : decisions.groupNpat * 0.25
    const dividendsReinvestedValue = (decisions.groupNpat - retainedNpat) * (decisions.dividendsReinvested / 10000)
    const totalNpatRetained = retainedNpat + dividendsReinvestedValue
    const additionalShareIssues = targetShareCapitalMovement - totalNpatRetained

    const closingShareholdersFunds = openingBalances.shareholdersFunds + totalNpatRetained + additionalShareIssues
    const regulatoryDeductions = totalCapitalDeductions
    const netRegulatoryCapital = closingShareholdersFunds + regulatoryDeductions

    const capitalRatioEstimate = (netRegulatoryCapital / totalRiskWeightedAsset) * 10000
    const band = getBand(capitalBands, capitalRatioEstimate)

    return (
      <Container>
        <PageHeader text={translate('treasury.screen4.screenHeader', 'CAPITAL MANAGEMENT').toUpperCase()} />
        {this.state.error && (
          <InlineError message={this.state.error} />
        )}
        <Content>
          <CardHelp border cardHelp={this.state.cardHelp} onCloseHandler={this.handlePressCloseHelp} />
          <ShareCapitalIssuedContainer>
            <ColumnHeaderContainer>
              <TranslatedText center proximaBold size='xl' uppercase value='treasury.screen4.table1Header' default='SHARE CAPITAL ISSUED' />
              <DenominationContainer>
                <Text darkgrey fontSize={12}>{denomination}</Text>
              </DenominationContainer>
            </ColumnHeaderContainer>
            <ContentContainer>
              <Section>
                <Row>
                  <TranslatedText size='s' uppercase value='treasury.screen4.table1Row1' default='TARGET SHARE CAPITAL MOVEMENT' />
                  <Text size='s'>{formatValue(targetShareCapitalMovement.toFixed(0))}</Text>
                </Row>
              </Section>
              <Section style={{ height: 160 }}>
                <Row>
                  <Text medium size='s' uppercase>{`${translate('treasury.screen4.table1Row2', 'FUNDED BY')}:`}</Text>
                </Row>
                <Row>
                  <Text size='s' uppercase>{`${translate('treasury.screen4.table1Row3', 'ESTIMATED GROUP NPAT')}:`}</Text>
                  {this.renderInput('groupNpat', decisions.groupNpat)}
                </Row>
                <Row>
                  <Text size='s' uppercase>{`${translate('treasury.screen4.table1Row4', 'RETAINED NPAT')}: *`}</Text>
                  <Text size='s'>{formatValue(retainedNpat.toFixed(0))}</Text>
                </Row>
              </Section>
              <Section style={{ height: 90, justifyContent: 'center' }}>
                <Row>
                  <Text medium primary size='s' uppercase>{`${translate('treasury.screen4.table1Row5', 'DIVIDENDS\nREINVESTED')}: *'`}</Text>
                  <HelpIcon>
                    <Touchable onPress={(evt) => this._onPressHelp(evt, dividendsReinvestedHelpTitle, dividendsReinvestedHelpBody, {
                      left: 220,
                      top: 200
                    })}
                    >
                      <Icon name='help' size='xxl' colour={theme.colours.bordergrey} />
                    </Touchable>
                  </HelpIcon>
                  <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <FakeInput>
                      <Text white medium center>{formatPercentage(decisions.dividendsReinvested, 0, true)}</Text>
                    </FakeInput>
                    <Text
                      size='s' darkgrey overrides={{
                        marginLeft: theme.gutterUnit
                      }}
                    >%
                    </Text>
                  </View>
                  <Text size='s'>{formatValue(dividendsReinvestedValue.toFixed(0))}</Text>
                </Row>
              </Section>
              <Section style={{ height: 60, justifyContent: 'center' }}>
                <Row>
                  <Text size='s' uppercase>{`${translate('treasury.screen4.table1Row6', 'TOTAL NPAT RETAINED')}: *`}</Text>
                  <Text size='s'>{formatValue(totalNpatRetained.toFixed(0))}</Text>
                </Row>
              </Section>
              <Section style={{ borderBottomWidth: 0, justifyContent: 'center', flex: 1 }}>
                <Row>
                  <TranslatedText medium primary size='s' uppercase value='treasury.screen4.table1Row7' default={'ADDITIONAL SHARE ISSUES /\n(BUYBACKS)'} />
                  <HelpIcon>
                    <Touchable onPress={(evt) => this._onPressHelp(evt, additionalShareIssuesHelpTitle, additionalShareIssuesHelpBody, {
                      left: 300,
                      top: 360
                    })}
                    >
                      <Icon name='help' size='xxl' colour={theme.colours.bordergrey} />
                    </Touchable>
                  </HelpIcon>
                  <FakeInput>
                    <Text white medium center>{formatValue(additionalShareIssues.toFixed(0))}</Text>
                  </FakeInput>
                </Row>
              </Section>
            </ContentContainer>
            <GreyFooter>
              <Text medium size='m' uppercase>{`* ${translate('treasury.screen4.table1footnote1', 'NOTE')}:`}</Text>
              <TranslatedText size='xs' value='treasury.screen4.table1footnote2' default={noteMessage} />
            </GreyFooter>
          </ShareCapitalIssuedContainer>
          <ForecastContainer>
            <ColumnHeaderContainer>
              <TranslatedText center proximaBold size='xl' uppercase value='treasury.screen4.table2Header' default='FORECAST CAPITAL / RATIO' />
              <DenominationContainer>
                <Text darkgrey fontSize={12}>{denomination}</Text>
              </DenominationContainer>
            </ColumnHeaderContainer>
            <ContentContainer>
              <Section style={{ paddingBottom: theme.gutterUnit }}>
                <Row>
                  <TranslatedText medium size='s' uppercase value='treasury.screen4.table2Row1' default={'OPENING SHAREHOLDERS\' FUNDS'} />
                </Row>
                <Row>
                  <TranslatedText size='s' darkgrey uppercase value='treasury.screen4.table2Row2' default={'OPENING SHAREHOLDERS\' FUNDS'} />
                  <Text size='s'>{formatValue(openingBalances.shareholdersFunds)}</Text>
                </Row>
                <Row>
                  <Text size='s' darkgrey uppercase>{`+ ${translate('treasury.screen4.table2Row3', 'SHARE CAPITAL GROWTH\n(EARNINGS DRIVEN)')}: *`}</Text>
                  <Text size='s'>{formatValue(totalNpatRetained.toFixed(0))}</Text>
                </Row>
                <Row>
                  <Text size='s' darkgrey uppercase>{`+ ${translate('treasury.screen4.table2Row4', 'SHARES ISSUED / (BOUGHT BACK)')}`}</Text>
                  <Text size='s'>{formatValue(additionalShareIssues.toFixed(0))}</Text>
                </Row>
              </Section>
              <Section style={{ height: 120, justifyContent: 'center' }}>
                <Row>
                  <Text size='s'>{`${translate('treasury.screen4.table2Row5', 'CLOSING SHAREHOLDERS\' FUNDS\n(ESTIMATED)')}: *`}</Text>
                  <Text size='s' medium>{formatValue(closingShareholdersFunds.toFixed(0))}</Text>
                </Row>
                <Row>
                  <Text size='s' darkgrey uppercase>{`- ${translate('treasury.screen4.table2Row6', 'REGULATORY CAPITAL DEDUCTIONS')}`}</Text>
                  <Text size='s'>{formatValue(regulatoryDeductions.toFixed(0))}</Text>
                </Row>
              </Section>
              <Section style={{ borderBottomWidth: 0, justifyContent: 'center', flex: 1 }}>
                <Row>
                  <Text size='s' uppercase>{`${translate('treasury.screen4.table2Row7', 'NET REGULATORY CAPITAL\n(ESTIMATED)')} *`}</Text>
                  <Text size='s' medium>{formatValue(netRegulatoryCapital.toFixed(0))}</Text>
                </Row>
                <Row>
                  <TranslatedText size='s' uppercase value='treasury.screen4.table2Row8' default='TOTAL RISK WEIGHTED ASSETS' />
                  <Text size='s' medium>{formatValue(totalRiskWeightedAsset.toFixed(0))}</Text>
                </Row>
              </Section>
            </ContentContainer>
            <Footer>
              <Text size='s' medium uppercase>{`${translate('treasury.screen4.table2Row9', 'CAPITAL RATIO (ESTIMATED)')} *`}</Text>
              <Text medium primary size='s'>{band}</Text>
              <Text medium primary size='s'>{formatPercentage(capitalRatioEstimate, 2)}</Text>
            </Footer>
          </ForecastContainer>
          <SlidersContainer>
            <VerticalSliderColumn>
              <ColumnHeaderContainer>
                <TranslatedText center size='s' value='treasury.screen4.slider1Label' default={'Dividends\nReinvested'} />
              </ColumnHeaderContainer>
              <Slider1Container>
                <Slider
                  key='dividendsReinvestedSlider'
                  value={decisions.dividendsReinvested}
                  onValueChange={value => this.onDividendsReinvestedChange(value)}
                  minimumValue={0}
                  maximumValue={2500}
                  minimumTrackTintColor={enableChanges ? theme.colours.blue : theme.colours.grey}
                  maximumTrackTintColor={theme.colours.grey}
                  thumbTintColor={enableChanges ? theme.colours.blue : theme.colours.grey}
                  step={100}
                  orientation='vertical'
                  inverted
                  disabled={!enableChanges}
                />
              </Slider1Container>
              <SliderValueContainer>
                <SliderValue mandatory>
                  <Text white center>{formatPercentage(decisions.dividendsReinvested, 0, true)}</Text>
                </SliderValue>
                <TranslatedText
                  overrides={{
                    position: 'absolute',
                    left: valueBoxWidth + 5
                  }} darkgrey
                  value='general.percentage'
                  default='%'
                />
              </SliderValueContainer>
            </VerticalSliderColumn>
            <VerticalSliderColumn>
              <ColumnHeaderContainer>
                <TranslatedText center size='s' value='treasury.screen4.slider2Label' default={'Share Issues /\n(Buy Backs)'} />
              </ColumnHeaderContainer>
              <Slider1Container>
                <Slider
                  key='shareIssuesBuyBacksSlider'
                  value={decisions.capitalRatioChange}
                  onValueChange={value => this.onShareIssuesBuyBacksChange(value)}
                  minimumValue={capitalSliderMin}
                  maximumValue={capitalSliderMax}
                  minimumTrackTintColor={enableChanges ? theme.colours.blue : theme.colours.grey}
                  maximumTrackTintColor={theme.colours.grey}
                  thumbTintColor={enableChanges ? theme.colours.blue : theme.colours.grey}
                  step={1}
                  orientation='vertical'
                  inverted
                  disabled={!enableChanges}
                />
              </Slider1Container>
              <SliderValueContainer>
                <SliderValue mandatory>
                  <Text white center>{formatValue(additionalShareIssues.toFixed(0))}</Text>
                </SliderValue>
                <TranslatedText
                  overrides={{
                    position: 'absolute',
                    left: valueBoxWidth + 5
                  }} darkgrey
                  value='general.denominationShort'
                  default='m'
                />
              </SliderValueContainer>
            </VerticalSliderColumn>
          </SlidersContainer>
        </Content>
      </Container>
    )
  }
}
